import { Filter } from '@common/models';

export const convertMapToRecord = (mapToBeConverted: Map<string, Filter>): Record<string, Filter> =>
    [...mapToBeConverted.entries()].reduce(
        (acc, [key, value]) => ({ ...acc, [key]: value }),
        {} as Record<string, Filter>
    );
